"use client";

import { Splash } from "@/components/Splash/Splash";
import { useTheme } from "@/hooks/useTheme";
import { Button } from "@cloudspire/shared/components/ui/button";
import { Flex } from "@cloudspire/shared/components/ui/flex";
import { useRouters } from "@cloudspire/shared/hooks/useRouters";
import NextLink from "next/link";
import { FormattedMessage, useIntl } from "react-intl";

export function Error429() {
  const intl = useIntl();

  const { nextjsAccountRouter } = useRouters();

  const { theme } = useTheme();

  return (
    <Flex
      flexDirection="column"
      h="100dvh"
      justifyContent="center"
      px="16px"
      py="32px"
    >
      <Splash
        description={intl.formatMessage({
          defaultMessage: "Code d’erreur: 429",
        })}
        src={nextjsAccountRouter.getUrl({
          id: "@account-v2/assets",
          parameters: { resource: `/assets/splashes/error/${theme}.svg` },
        })}
        title={intl.formatMessage({
          defaultMessage: "Trop de requêtes",
        })}
      >
        <NextLink
          href={nextjsAccountRouter.getUrl({
            id: "@account-v2/account",
          })}
        >
          <Button colorPalette="primary">
            <FormattedMessage defaultMessage="Revenir à l’accueil" />
          </Button>
        </NextLink>
      </Splash>
    </Flex>
  );
}
